import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { getAccountNameByUuid } from 'src/app/utils/local-storage.util';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  private isInitialized: boolean = false;

  constructor() {}

  initAmplitude(): string | null {
    // amplitude init for all environments except local
    if (environment.envName !== 'local') {
      try {
        amplitude.init(environment.amplitudeApiKey, {
          autocapture: {
            attribution: true,
            fileDownloads: false,
            formInteractions: false,
            pageViews: true,
            sessions: true,
            elementInteractions: false // Disable element interactions to prevent freezing
          },
        });

        // Add the engagement plugin for guides and surveys on dev env
        if (environment.envName === 'dev') {
          amplitude.add(engagementPlugin());
        }

        // Set the userUuid in Amplitude
        const userUuid = localStorage.getItem('user_uuid');
        if (userUuid) {
          console.log(`Amplitude track userUuid in ${environment.envName}`);
          amplitude.setUserId(userUuid);

          const account_id = localStorage.getItem('current_account_uuid') || '';
          const account_name = getAccountNameByUuid(account_id);

          // set user properties
          const userProps = new amplitude.Identify();
          userProps.set('account_id', account_id);
          userProps.set('account_name', account_name);
          console.log(
            `Amplitude identify account_id ${account_id} account_name ${account_name}`
          );
          amplitude.identify(userProps);
          this.isInitialized = true;
          return userUuid;
        }
        this.isInitialized = true;
      } catch (error) {
        console.warn('Amplitude initialization failed:', error);
        this.isInitialized = false;
      }
    }
    return null;
  }

  trackEvent(eventName: string, eventProperties?: any): string {
    // Only track events if Amplitude is initialized (not in local environment)
    if (!this.isInitialized || environment.envName === 'local') {
      return eventName;
    }

    try {
      amplitude.track(eventName, {
        ...eventProperties,
      });
      console.log(`AMPLITUDE ::: track [${eventName}]`, { eventProperties });
    } catch (error) {
      // Silently fail if tracking fails to prevent app crashes
      console.warn('Amplitude tracking failed:', error);
    }
    return eventName;
  }

  setUserId(userId: string): void {
    if (this.isInitialized && environment.envName !== 'local') {
      try {
        amplitude.setUserId(userId);
      } catch (error) {
        console.warn('Amplitude setUserId failed:', error);
      }
    }
  }
}
